module.exports = __webpack_public_path__ + "img/a9f9e54.svg";